import { render, staticRenderFns } from "./DocsTable.vue?vue&type=template&id=6033b4ca&scoped=true"
import script from "./DocsTable.vue?vue&type=script&lang=js"
export * from "./DocsTable.vue?vue&type=script&lang=js"
import style0 from "./DocsTable.vue?vue&type=style&index=0&id=6033b4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033b4ca",
  null
  
)

export default component.exports